var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"job-photo-list"},[_c('div',{staticClass:"job-photo-list__main",style:({
      backgroundImage: 'url(' + _vm.toolPhoto + ')',
      backgroundSize: 'contain',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
    })}),_c('div',{staticClass:"job-photo-list__others"},[_vm._l((_vm.job.gallery),function(image,index){return (_vm.job.gallery.length > 0)?[_c('div',{key:index,staticClass:"photo",on:{"mouseover":function($event){return _vm.setToolPhoto(image)}}},[_c('b-img-lazy',{attrs:{"src":image.thumb_url,"fluid":""}})],1)]:_vm._e()})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }